/* eslint-disable */

/** select columns of table "argo.vw_material_model_processes_by_class" */
export enum ArgoVwMaterialModelProcessesByClassSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

